import React from "react";
import SbEditable from "storyblok-react";

const HtmlBlock = ({ blok }) => {
  return (
    <SbEditable content={blok} key={blok._uid}>
      <div 
        className="prose lg:text-base text-sm mt-4"
        dangerouslySetInnerHTML={{ __html: blok.raw_html }}
      />
    </SbEditable>
  );
};

export default HtmlBlock;
